/* eslint-disable no-console */
import { takeLatest, takeEvery, put, select } from 'redux-saga/effects';
import fileDownload from 'js-file-download';
import * as TypeActions from '../store/relatorioJob/actionsTypes';
import * as ToastTypeActions from '../store/toast/actionsTypes';
import BaseService from '../services/BaseService';
import FileService from '../services/FileService';
import { downloadPresignedUrl } from '../helpers/downloadPresignedUrl';
import {
  RELATORIO_JOB_MENU_SIZE,
  RELATORIO_JOB_TIPO,
  getRelatorioDocumentoPath,
  getRelatorioStatusPath,
  isRelatorioJobInFlight,
  normalizeRelatorioJob,
  parseRelatorioJobsPage,
  filterDownloadableRelatorioJobs,
} from '../helpers/relatorioJob';

function* fetchPreview() {
  try {
    const response = yield BaseService.get({
      url: `reports/jobs?p=0&s=${RELATORIO_JOB_MENU_SIZE}`,
    });
    const page = parseRelatorioJobsPage(response.data);
    yield put({
      type: TypeActions.RELATORIO_JOB_FETCH_PREVIEW_SUCCESS,
      items: filterDownloadableRelatorioJobs(page.items),
      totalElements: filterDownloadableRelatorioJobs(page.items).length
        ? page.totalElements
        : 0,
    });
  } catch (error) {
    console.log(error);
  }
  yield refreshInFlightJobs();
}

function* refreshInFlightJobs() {
  const items = yield select((state) => state.rootState.relatorioJob.items || []);
  const inflight = items.filter((job) => isRelatorioJobInFlight(job.status));
  for (let i = 0; i < inflight.length; i += 1) {
    const job = inflight[i];
    const path = getRelatorioStatusPath(job);
    if (path) {
      try {
        const response = yield BaseService.get({ url: path });
        yield put({
          type: TypeActions.RELATORIO_JOB_START_SUCCESS,
          job: normalizeRelatorioJob({
            ...job,
            ...response.data,
            tipo: (response.data && response.data.tipo) || job.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA,
          }),
        });
      } catch (error) {
        console.log(error);
      }
    }
  }
}

function* startAuditoriaFaixa({ nsirId }) {
  try {
    const response = yield BaseService.post({
      url: `reports/auditoria-faixa/${nsirId}`,
    });
    const job = normalizeRelatorioJob({
      ...response.data,
      tipo: response.data.tipo || RELATORIO_JOB_TIPO.AUDITORIA_FAIXA,
    });
    yield put({ type: TypeActions.RELATORIO_JOB_START_SUCCESS, job });
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_SUCCESS,
      message: 'Solicitação recebida. O arquivo será gerado em segundo plano.',
    });
  } catch (error) {
    console.log(error);
    const status = error.response && error.response.status;
    let message = 'Erro ao solicitar o relatório de Auditoria de Faixa!';
    if (status === 400) message = 'Esta NSIR não é do tipo Auditoria de Faixa.';
    if (status === 403) message = 'Sem permissão para gerar este relatório.';
    if (status === 404) message = 'NSIR não encontrada.';
    if (error.response && error.response.data && error.response.data.mensagem) {
      message = error.response.data.mensagem;
    }
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  }
}

function* downloadJob({ job }) {
  try {
    const path = getRelatorioDocumentoPath(job);
    if (!path) {
      yield put({
        type: ToastTypeActions.TOAST_MESSAGE_ERROR,
        message: 'Tipo de relatório não suportado para download.',
      });
      return;
    }
    const response = yield BaseService.get({ url: path });
    const url = response.data.url;
    const nome = response.data.nome || job.nomeArquivo || 'relatorio.docx';
    try {
      const file = yield FileService.getFile(url);
      yield fileDownload(file.data, nome);
    } catch (downloadError) {
      console.log(downloadError);
      downloadPresignedUrl(url);
    }
  } catch (error) {
    console.log(error);
    const status = error.response && error.response.status;
    let message = 'Erro ao baixar o relatório!';
    if (status === 409) message = 'O relatório ainda não está pronto.';
    if (status === 404) message = 'Arquivo indisponível. Gere o relatório novamente.';
    yield put({
      type: ToastTypeActions.TOAST_MESSAGE_ERROR,
      message,
    });
  } finally {
    yield put({ type: TypeActions.RELATORIO_JOB_DOWNLOAD_DONE });
  }
}

function* watchRelatorioJob() {
  yield takeLatest(TypeActions.RELATORIO_JOB_FETCH_PREVIEW, fetchPreview);
  yield takeEvery(TypeActions.RELATORIO_JOB_START_AUDITORIA_FAIXA, startAuditoriaFaixa);
  yield takeEvery(TypeActions.RELATORIO_JOB_DOWNLOAD, downloadJob);
}

export default watchRelatorioJob;
